export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Datetime: { input: Date; output: Date };
  Map: { input: object; output: object };
  Upload: { input: File | File[] | Blob; output: File | File[] | Blob };
  Uri: { input: URL; output: URL };
};

export type AdvanceParticipationPayload = {
  __typename?: "AdvanceParticipationPayload";
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result: Maybe<Participation>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars["Boolean"]["output"];
};

/** Answer interface */
export type Answer = {
  id: Scalars["ID"]["output"];
  insertedAt: Scalars["Datetime"]["output"];
  participation: Participation;
  question: Question;
  updatedAt: Scalars["Datetime"]["output"];
};

/** Candidate */
export type Candidate = Node &
  Resource & {
    __typename?: "Candidate";
    email: Scalars["String"]["output"];
    firstname: Maybe<Scalars["String"]["output"]>;
    /** The ID of an object */
    id: Scalars["ID"]["output"];
    import: Maybe<CandidateImport>;
    insertedAt: Scalars["Datetime"]["output"];
    lastname: Maybe<Scalars["String"]["output"]>;
    metadata: Scalars["Map"]["output"];
    reminderEmailSentAt: Maybe<Scalars["Datetime"]["output"]>;
    status: CandidateStatus;
    survey: Survey;
    updatedAt: Scalars["Datetime"]["output"];
  };

export type CandidateConnection = {
  __typename?: "CandidateConnection";
  edges: Maybe<Array<Maybe<CandidateEdge>>>;
  pageInfo: PageInfo;
};

export type CandidateEdge = {
  __typename?: "CandidateEdge";
  cursor: Maybe<Scalars["String"]["output"]>;
  node: Maybe<Candidate>;
};

/** Candidate import */
export type CandidateImport = Node &
  Resource & {
    __typename?: "CandidateImport";
    candidates: Maybe<CandidateConnection>;
    filename: Scalars["String"]["output"];
    /** The ID of an object */
    id: Scalars["ID"]["output"];
    insertedAt: Scalars["Datetime"]["output"];
    survey: Survey;
    updatedAt: Scalars["Datetime"]["output"];
  };

/** Candidate import */
export type CandidateImportCandidatesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CandidateImportConnection = {
  __typename?: "CandidateImportConnection";
  edges: Maybe<Array<Maybe<CandidateImportEdge>>>;
  pageInfo: PageInfo;
};

export type CandidateImportEdge = {
  __typename?: "CandidateImportEdge";
  cursor: Maybe<Scalars["String"]["output"]>;
  node: Maybe<CandidateImport>;
};

export enum CandidateStatus {
  Finished = "FINISHED",
  Invited = "INVITED",
  New = "NEW",
  Ongoing = "ONGOING",
}

/** Caplena project */
export type CaplenaProject = {
  __typename?: "CaplenaProject";
  columns: Maybe<Array<Maybe<Column>>>;
  id: Scalars["ID"]["output"];
  insertedAt: Scalars["Datetime"]["output"];
  name: Maybe<Scalars["String"]["output"]>;
  tags: Array<Scalars["String"]["output"]>;
  updatedAt: Scalars["Datetime"]["output"];
};

/** Caplena project */
export type CaplenaProjectColumnsArgs = {
  type?: InputMaybe<Scalars["String"]["input"]>;
};

/** Client */
export type Client = Node &
  Resource & {
    __typename?: "Client";
    corporateConfiguration: ClientCorporateConfiguration;
    /** The ID of an object */
    id: Scalars["ID"]["output"];
    insertedAt: Scalars["Datetime"]["output"];
    isActive: Scalars["Boolean"]["output"];
    name: Maybe<Scalars["String"]["output"]>;
    updatedAt: Scalars["Datetime"]["output"];
  };

export type ClientConnection = {
  __typename?: "ClientConnection";
  edges: Maybe<Array<Maybe<ClientEdge>>>;
  pageInfo: PageInfo;
};

/** Client corporate configuration */
export type ClientCorporateConfiguration = {
  __typename?: "ClientCorporateConfiguration";
  logo: Maybe<Scalars["Uri"]["output"]>;
  primaryColor: Maybe<Scalars["String"]["output"]>;
  secondaryColor: Maybe<Scalars["String"]["output"]>;
};

/** Client corporate configuration */
export type ClientCorporateConfigurationLogoArgs = {
  size: ImageSize;
};

/** Client corporate configuration input */
export type ClientCorporateConfigurationInput = {
  logo?: InputMaybe<Scalars["Upload"]["input"]>;
  primaryColor?: InputMaybe<Scalars["String"]["input"]>;
  secondaryColor?: InputMaybe<Scalars["String"]["input"]>;
};

export type ClientEdge = {
  __typename?: "ClientEdge";
  cursor: Maybe<Scalars["String"]["output"]>;
  node: Maybe<Client>;
};

export type Column = {
  __typename?: "Column";
  name: Scalars["String"]["output"];
  ref: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

export type CompleteParticipationPayload = {
  __typename?: "CompleteParticipationPayload";
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result: Maybe<Participation>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars["Boolean"]["output"];
};

export type CreateClientInput = {
  corporateConfiguration?: InputMaybe<ClientCorporateConfigurationInput>;
  name: Scalars["String"]["input"];
};

export type CreateClientPayload = {
  __typename?: "CreateClientPayload";
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result: Maybe<Client>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars["Boolean"]["output"];
};

export type CreateMetadataQuestionInput = {
  caplenaRef?: InputMaybe<Scalars["String"]["input"]>;
  createCaplenaColumn?: InputMaybe<Scalars["Boolean"]["input"]>;
  surveyId: Scalars["ID"]["input"];
  title: Scalars["String"]["input"];
};

export type CreateMetadataQuestionPayload = {
  __typename?: "CreateMetadataQuestionPayload";
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result: Maybe<MetadataQuestion>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars["Boolean"]["output"];
};

export type CreateMultipleChoiceAnswerInput = {
  questionId: Scalars["ID"]["input"];
  value: Array<Scalars["String"]["input"]>;
};

export type CreateMultipleChoiceAnswerPayload = {
  __typename?: "CreateMultipleChoiceAnswerPayload";
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result: Maybe<MultipleChoiceAnswer>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars["Boolean"]["output"];
};

export type CreateMultipleChoiceQuestionInput = {
  caplenaRef?: InputMaybe<Scalars["String"]["input"]>;
  choices: Array<Scalars["String"]["input"]>;
  createCaplenaColumn?: InputMaybe<Scalars["Boolean"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  isSkippable?: InputMaybe<Scalars["Boolean"]["input"]>;
  maxChoices: Scalars["Int"]["input"];
  minChoices: Scalars["Int"]["input"];
  previousQuestionId?: InputMaybe<Scalars["ID"]["input"]>;
  surveyId: Scalars["ID"]["input"];
  title: Scalars["String"]["input"];
};

export type CreateMultipleChoiceQuestionPayload = {
  __typename?: "CreateMultipleChoiceQuestionPayload";
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result: Maybe<MultipleChoiceQuestion>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars["Boolean"]["output"];
};

export type CreateParticipationPayload = {
  __typename?: "CreateParticipationPayload";
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result: Maybe<Participation>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars["Boolean"]["output"];
};

export type CreateProjectInput = {
  clientId: Scalars["ID"]["input"];
  corporateConfiguration?: InputMaybe<ProjectCorporateConfigurationInput>;
  name: Scalars["String"]["input"];
};

export type CreateProjectPayload = {
  __typename?: "CreateProjectPayload";
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result: Maybe<Project>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars["Boolean"]["output"];
};

export type CreateSurveyInput = {
  autoSendInvitationEmails: Scalars["Boolean"]["input"];
  backgroundImage?: InputMaybe<Scalars["Upload"]["input"]>;
  caplenaId?: InputMaybe<Scalars["ID"]["input"]>;
  corporateConfiguration?: InputMaybe<SurveyCorporateConfigurationInput>;
  endButtonText?: InputMaybe<Scalars["String"]["input"]>;
  finishEmailConfiguration?: InputMaybe<FinishEmailConfigurationInput>;
  footerMarkdown?: InputMaybe<Scalars["String"]["input"]>;
  introImage?: InputMaybe<Scalars["Upload"]["input"]>;
  introMarkdown?: InputMaybe<Scalars["String"]["input"]>;
  introVideo?: InputMaybe<Scalars["String"]["input"]>;
  invitationEmailConfiguration?: InputMaybe<InvitationEmailConfigurationInput>;
  language?: InputMaybe<SurveyLanguage>;
  name: Scalars["String"]["input"];
  outroImage?: InputMaybe<Scalars["Upload"]["input"]>;
  outroMarkdown?: InputMaybe<Scalars["String"]["input"]>;
  outroVideo?: InputMaybe<Scalars["String"]["input"]>;
  precedingSurveyId?: InputMaybe<Scalars["ID"]["input"]>;
  projectId: Scalars["ID"]["input"];
  reminderEmailConfiguration?: InputMaybe<ReminderEmailConfigurationInput>;
  resultUrl?: InputMaybe<Scalars["String"]["input"]>;
  showPullsBranding?: InputMaybe<Scalars["Boolean"]["input"]>;
  showResultsFromPrecedingSurvey?: InputMaybe<Scalars["Boolean"]["input"]>;
  startButtonText?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateSurveyPayload = {
  __typename?: "CreateSurveyPayload";
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result: Maybe<Survey>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars["Boolean"]["output"];
};

export type CreateTextAnswerInput = {
  questionId: Scalars["ID"]["input"];
  value: Scalars["String"]["input"];
};

export type CreateTextAnswerPayload = {
  __typename?: "CreateTextAnswerPayload";
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result: Maybe<TextAnswer>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars["Boolean"]["output"];
};

export type CreateTextQuestionInput = {
  caplenaRef?: InputMaybe<Scalars["String"]["input"]>;
  createCaplenaColumn?: InputMaybe<Scalars["Boolean"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  isSkippable?: InputMaybe<Scalars["Boolean"]["input"]>;
  previousQuestionId?: InputMaybe<Scalars["ID"]["input"]>;
  surveyId: Scalars["ID"]["input"];
  title: Scalars["String"]["input"];
};

export type CreateTextQuestionPayload = {
  __typename?: "CreateTextQuestionPayload";
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result: Maybe<TextQuestion>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars["Boolean"]["output"];
};

export type DeleteAnswerInput = {
  answerId: Scalars["ID"]["input"];
};

export type DeleteAnswerPayload = {
  __typename?: "DeleteAnswerPayload";
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages: Maybe<Array<Maybe<ValidationMessage>>>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars["Boolean"]["output"];
};

export type DeleteCandidateInput = {
  candidateId: Scalars["ID"]["input"];
};

export type DeleteCandidatePayload = {
  __typename?: "DeleteCandidatePayload";
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages: Maybe<Array<Maybe<ValidationMessage>>>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars["Boolean"]["output"];
};

export type DeleteClientInput = {
  clientId: Scalars["ID"]["input"];
};

export type DeleteClientPayload = {
  __typename?: "DeleteClientPayload";
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages: Maybe<Array<Maybe<ValidationMessage>>>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars["Boolean"]["output"];
};

export type DeleteProjectInput = {
  projectId: Scalars["ID"]["input"];
};

export type DeleteProjectPayload = {
  __typename?: "DeleteProjectPayload";
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages: Maybe<Array<Maybe<ValidationMessage>>>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars["Boolean"]["output"];
};

export type DeleteQuestionInput = {
  questionId: Scalars["ID"]["input"];
};

export type DeleteQuestionPayload = {
  __typename?: "DeleteQuestionPayload";
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages: Maybe<Array<Maybe<ValidationMessage>>>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars["Boolean"]["output"];
};

export type DeleteSurveyInput = {
  caplenaCleanup?: InputMaybe<Scalars["Boolean"]["input"]>;
  surveyId: Scalars["ID"]["input"];
};

export type DeleteSurveyPayload = {
  __typename?: "DeleteSurveyPayload";
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages: Maybe<Array<Maybe<ValidationMessage>>>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars["Boolean"]["output"];
};

/** Finish email configuration. */
export type FinishEmailConfiguration = {
  __typename?: "FinishEmailConfiguration";
  content: Scalars["String"]["output"];
  greeting: Scalars["String"]["output"];
  insertedAt: Scalars["Datetime"]["output"];
  subject: Scalars["String"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

/** Finish email configuration input */
export type FinishEmailConfigurationInput = {
  content: Scalars["String"]["input"];
  greeting: Scalars["String"]["input"];
  subject: Scalars["String"]["input"];
};

export enum ImageSize {
  /** 1920 X 1080 */
  BackgroundLg = "BACKGROUND_LG",
  /** 3840 X 2160 */
  BackgroundLgX2 = "BACKGROUND_LG_X2",
  /** 1280 X 720 */
  BackgroundMd = "BACKGROUND_MD",
  /** 2560 X 1440 */
  BackgroundMdX2 = "BACKGROUND_MD_X2",
  /** 960 X 540 */
  BackgroundSm = "BACKGROUND_SM",
  /** 1920 X 1080 */
  BackgroundSmX2 = "BACKGROUND_SM_X2",
  /** 1024 X 128 */
  Large = "LARGE",
  /** 2048 X 256 */
  LargeX2 = "LARGE_X2",
  /** Original Upload Size */
  Original = "ORIGINAL",
  /** 256 X 32 */
  Small = "SMALL",
  /** 512 X 64 */
  SmallX2 = "SMALL_X2",
  /** 32 X 32 */
  Thumbnail = "THUMBNAIL",
  /** 64 X 64 */
  ThumbnailX2 = "THUMBNAIL_X2",
  /** 128 X 128 */
  ThumbnailX3 = "THUMBNAIL_X3",
  /** 256 X 256 */
  ThumbnailX4 = "THUMBNAIL_X4",
}

export type ImportCandidatesInput = {
  /** CSV containing the candidates */
  file: Scalars["Upload"]["input"];
  /** Survey where candidates will be imported to */
  surveyId: Scalars["ID"]["input"];
};

export type ImportCandidatesPayload = {
  __typename?: "ImportCandidatesPayload";
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result: Maybe<CandidateImport>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars["Boolean"]["output"];
};

export type ImportPrecedingSurveyCandidatesInput = {
  candidateStatuses?: InputMaybe<Array<CandidateStatus>>;
  surveyId: Scalars["ID"]["input"];
};

export type ImportPrecedingSurveyCandidatesPayload = {
  __typename?: "ImportPrecedingSurveyCandidatesPayload";
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages: Maybe<Array<Maybe<ValidationMessage>>>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars["Boolean"]["output"];
};

/** Invitation email configuration. */
export type InvitationEmailConfiguration = {
  __typename?: "InvitationEmailConfiguration";
  buttonText: Scalars["String"]["output"];
  content: Scalars["String"]["output"];
  ending: Scalars["String"]["output"];
  greeting: Scalars["String"]["output"];
  insertedAt: Scalars["Datetime"]["output"];
  subject: Scalars["String"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

/** Invitation email configuration input */
export type InvitationEmailConfigurationInput = {
  buttonText: Scalars["String"]["input"];
  content: Scalars["String"]["input"];
  ending: Scalars["String"]["input"];
  greeting: Scalars["String"]["input"];
  subject: Scalars["String"]["input"];
};

/** Metadata question. */
export type MetadataQuestion = Node &
  Question &
  Resource & {
    __typename?: "MetadataQuestion";
    caplenaRef: Maybe<Scalars["String"]["output"]>;
    createCaplenaColumn: Maybe<Scalars["Boolean"]["output"]>;
    description: Maybe<Scalars["String"]["output"]>;
    /** The ID of an object */
    id: Scalars["ID"]["output"];
    insertedAt: Scalars["Datetime"]["output"];
    isSkippable: Maybe<Scalars["Boolean"]["output"]>;
    previousQuestion: Maybe<Question>;
    survey: Survey;
    title: Scalars["String"]["output"];
    updatedAt: Scalars["Datetime"]["output"];
  };

/** Text answer */
export type MultipleChoiceAnswer = Answer &
  Node &
  Resource & {
    __typename?: "MultipleChoiceAnswer";
    /** The ID of an object */
    id: Scalars["ID"]["output"];
    insertedAt: Scalars["Datetime"]["output"];
    participation: Participation;
    question: Question;
    updatedAt: Scalars["Datetime"]["output"];
    value: Array<Scalars["String"]["output"]>;
  };

/** Multiple choice question. */
export type MultipleChoiceQuestion = Node &
  Question &
  Resource & {
    __typename?: "MultipleChoiceQuestion";
    caplenaRef: Maybe<Scalars["String"]["output"]>;
    choices: Maybe<Array<Scalars["String"]["output"]>>;
    createCaplenaColumn: Maybe<Scalars["Boolean"]["output"]>;
    description: Maybe<Scalars["String"]["output"]>;
    /** The ID of an object */
    id: Scalars["ID"]["output"];
    insertedAt: Scalars["Datetime"]["output"];
    isSkippable: Maybe<Scalars["Boolean"]["output"]>;
    maxChoices: Scalars["Int"]["output"];
    minChoices: Scalars["Int"]["output"];
    previousQuestion: Maybe<Question>;
    survey: Survey;
    title: Scalars["String"]["output"];
    updatedAt: Scalars["Datetime"]["output"];
  };

export type Node = {
  /** The ID of the object. */
  id: Scalars["ID"]["output"];
};

export type PageInfo = {
  __typename?: "PageInfo";
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars["String"]["output"]>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars["Boolean"]["output"];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars["Boolean"]["output"];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars["String"]["output"]>;
};

/** Participation */
export type Participation = Node &
  Resource & {
    __typename?: "Participation";
    completedAt: Maybe<Scalars["Datetime"]["output"]>;
    currentTopic: Maybe<Topic>;
    hasNextTopic: Scalars["Boolean"]["output"];
    hasPreviousTopic: Scalars["Boolean"]["output"];
    /** The ID of an object */
    id: Scalars["ID"]["output"];
    insertedAt: Scalars["Datetime"]["output"];
    participationToken: Scalars["String"]["output"];
    survey: Survey;
    testing: Scalars["Boolean"]["output"];
    updatedAt: Scalars["Datetime"]["output"];
  };

/** Project */
export type Project = Node &
  Resource & {
    __typename?: "Project";
    client: Client;
    corporateConfiguration: Maybe<ProjectCorporateConfiguration>;
    /** The ID of an object */
    id: Scalars["ID"]["output"];
    inheritedCorporateConfiguration: SurveyCorporateConfiguration;
    insertedAt: Scalars["Datetime"]["output"];
    isActive: Scalars["Boolean"]["output"];
    name: Maybe<Scalars["String"]["output"]>;
    surveys: Maybe<SurveyConnection>;
    updatedAt: Scalars["Datetime"]["output"];
  };

/** Project */
export type ProjectSurveysArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ProjectConnection = {
  __typename?: "ProjectConnection";
  edges: Maybe<Array<Maybe<ProjectEdge>>>;
  pageInfo: PageInfo;
};

/** Project corporate configuration */
export type ProjectCorporateConfiguration = {
  __typename?: "ProjectCorporateConfiguration";
  logo: Maybe<Scalars["Uri"]["output"]>;
  primaryColor: Maybe<Scalars["String"]["output"]>;
  secondaryColor: Maybe<Scalars["String"]["output"]>;
};

/** Project corporate configuration */
export type ProjectCorporateConfigurationLogoArgs = {
  size: ImageSize;
};

/** Project corporate configuration input */
export type ProjectCorporateConfigurationInput = {
  logo?: InputMaybe<Scalars["Upload"]["input"]>;
  primaryColor?: InputMaybe<Scalars["String"]["input"]>;
  secondaryColor?: InputMaybe<Scalars["String"]["input"]>;
};

export type ProjectEdge = {
  __typename?: "ProjectEdge";
  cursor: Maybe<Scalars["String"]["output"]>;
  node: Maybe<Project>;
};

/** Question interface */
export type Question = {
  caplenaRef: Maybe<Scalars["String"]["output"]>;
  createCaplenaColumn: Maybe<Scalars["Boolean"]["output"]>;
  description: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  insertedAt: Scalars["Datetime"]["output"];
  isSkippable: Maybe<Scalars["Boolean"]["output"]>;
  previousQuestion: Maybe<Question>;
  survey: Survey;
  title: Scalars["String"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

export type QuestionConnection = {
  __typename?: "QuestionConnection";
  edges: Maybe<Array<Maybe<QuestionEdge>>>;
  pageInfo: PageInfo;
};

export type QuestionEdge = {
  __typename?: "QuestionEdge";
  cursor: Maybe<Scalars["String"]["output"]>;
  node: Maybe<Question>;
};

export enum QuestionType {
  Metadata = "METADATA",
  MultipleChoice = "MULTIPLE_CHOICE",
  Text = "TEXT",
}

export type RegressParticipationPayload = {
  __typename?: "RegressParticipationPayload";
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result: Maybe<Participation>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars["Boolean"]["output"];
};

/** Reminder email configuration. */
export type ReminderEmailConfiguration = {
  __typename?: "ReminderEmailConfiguration";
  buttonText: Scalars["String"]["output"];
  content: Scalars["String"]["output"];
  ending: Scalars["String"]["output"];
  greeting: Scalars["String"]["output"];
  insertedAt: Scalars["Datetime"]["output"];
  subject: Scalars["String"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

/** Reminder email configuration input */
export type ReminderEmailConfigurationInput = {
  buttonText: Scalars["String"]["input"];
  content: Scalars["String"]["input"];
  ending: Scalars["String"]["input"];
  greeting: Scalars["String"]["input"];
  subject: Scalars["String"]["input"];
};

export type Resource = {
  id: Scalars["ID"]["output"];
  insertedAt: Scalars["Datetime"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

export type RootMutationType = {
  __typename?: "RootMutationType";
  /** Returns the update participation where the current question is set to the next. */
  advanceParticipation: Maybe<AdvanceParticipationPayload>;
  /** Complete a participation if a valid token is provided. */
  completeParticipation: Maybe<CompleteParticipationPayload>;
  /** Create a client. */
  createClient: Maybe<CreateClientPayload>;
  /** Create a meta question for a survey. */
  createMetadataQuestion: Maybe<CreateMetadataQuestionPayload>;
  /** Create a multiple choice answer for a question. */
  createMultipleChoiceAnswer: Maybe<CreateMultipleChoiceAnswerPayload>;
  /** Create a multiple choice question for a survey. */
  createMultipleChoiceQuestion: Maybe<CreateMultipleChoiceQuestionPayload>;
  /** Creates a participation or returns the existing one if a valid token is provided. */
  createParticipation: Maybe<CreateParticipationPayload>;
  /** Create a project. */
  createProject: Maybe<CreateProjectPayload>;
  /** Create a survey. */
  createSurvey: Maybe<CreateSurveyPayload>;
  /** Create a text answer for a question. */
  createTextAnswer: Maybe<CreateTextAnswerPayload>;
  /** Create a text question for a survey. */
  createTextQuestion: Maybe<CreateTextQuestionPayload>;
  /** Delete answer. */
  deleteAnswer: Maybe<DeleteAnswerPayload>;
  /** Delete a candidate. */
  deleteCandidate: Maybe<DeleteCandidatePayload>;
  /** Delete a client. */
  deleteClient: Maybe<DeleteClientPayload>;
  /** Delete a project. */
  deleteProject: Maybe<DeleteProjectPayload>;
  /** Delete question of a survey. */
  deleteQuestion: Maybe<DeleteQuestionPayload>;
  /** Delete a survey. */
  deleteSurvey: Maybe<DeleteSurveyPayload>;
  /** Imports candidate_imports with a csv file. */
  importCandidates: Maybe<ImportCandidatesPayload>;
  /** Import candidates from preceding survey. */
  importPrecedingSurveyCandidates: Maybe<ImportPrecedingSurveyCandidatesPayload>;
  /** Returns the update participation where the current question is set to the previous. */
  regressParticipation: Maybe<RegressParticipationPayload>;
  /** Send finish email to candidates of the survey. */
  sendFinishEmails: Maybe<SendFinishEmailsPayload>;
  /** Send invitaions to the candidates of the survey. */
  sendInvitationEmails: Maybe<SendInvitationEmailsPayload>;
  /** Send reminder to the candidates of the survey. */
  sendReminderEmails: Maybe<SendReminderEmailsPayload>;
  /** Update a client. */
  updateClient: Maybe<UpdateClientPayload>;
  /** Update a meta question of a survey. */
  updateMetadataQuestion: Maybe<UpdateMetadataQuestionPayload>;
  /** Update a multiple choice answer of a question. */
  updateMultipleChoiceAnswer: Maybe<UpdateMultipleChoiceAnswerPayload>;
  /** Update a multiple choice question of a survey. */
  updateMultipleChoiceQuestion: Maybe<UpdateMultipleChoiceQuestionPayload>;
  /** Update a project. */
  updateProject: Maybe<UpdateProjectPayload>;
  /** Update a survey. */
  updateSurvey: Maybe<UpdateSurveyPayload>;
  /** Update a text answer of a question. */
  updateTextAnswer: Maybe<UpdateTextAnswerPayload>;
  /** Update a text question of a survey. */
  updateTextQuestion: Maybe<UpdateTextQuestionPayload>;
};

export type RootMutationTypeCreateClientArgs = {
  input: CreateClientInput;
};

export type RootMutationTypeCreateMetadataQuestionArgs = {
  input: CreateMetadataQuestionInput;
};

export type RootMutationTypeCreateMultipleChoiceAnswerArgs = {
  input: CreateMultipleChoiceAnswerInput;
};

export type RootMutationTypeCreateMultipleChoiceQuestionArgs = {
  input: CreateMultipleChoiceQuestionInput;
};

export type RootMutationTypeCreateProjectArgs = {
  input: CreateProjectInput;
};

export type RootMutationTypeCreateSurveyArgs = {
  input: CreateSurveyInput;
};

export type RootMutationTypeCreateTextAnswerArgs = {
  input: CreateTextAnswerInput;
};

export type RootMutationTypeCreateTextQuestionArgs = {
  input: CreateTextQuestionInput;
};

export type RootMutationTypeDeleteAnswerArgs = {
  input: DeleteAnswerInput;
};

export type RootMutationTypeDeleteCandidateArgs = {
  input: DeleteCandidateInput;
};

export type RootMutationTypeDeleteClientArgs = {
  input: DeleteClientInput;
};

export type RootMutationTypeDeleteProjectArgs = {
  input: DeleteProjectInput;
};

export type RootMutationTypeDeleteQuestionArgs = {
  input: DeleteQuestionInput;
};

export type RootMutationTypeDeleteSurveyArgs = {
  input: DeleteSurveyInput;
};

export type RootMutationTypeImportCandidatesArgs = {
  input: ImportCandidatesInput;
};

export type RootMutationTypeImportPrecedingSurveyCandidatesArgs = {
  input: ImportPrecedingSurveyCandidatesInput;
};

export type RootMutationTypeSendFinishEmailsArgs = {
  input: SendFinishEmailsInput;
};

export type RootMutationTypeSendInvitationEmailsArgs = {
  input: SendInvitationEmailsInput;
};

export type RootMutationTypeSendReminderEmailsArgs = {
  input: SendReminderEmailsInput;
};

export type RootMutationTypeUpdateClientArgs = {
  input: UpdateClientInput;
};

export type RootMutationTypeUpdateMetadataQuestionArgs = {
  input: UpdateMetadataQuestionInput;
};

export type RootMutationTypeUpdateMultipleChoiceAnswerArgs = {
  input: UpdateMultipleChoiceAnswerInput;
};

export type RootMutationTypeUpdateMultipleChoiceQuestionArgs = {
  input: UpdateMultipleChoiceQuestionInput;
};

export type RootMutationTypeUpdateProjectArgs = {
  input: UpdateProjectInput;
};

export type RootMutationTypeUpdateSurveyArgs = {
  input: UpdateSurveyInput;
};

export type RootMutationTypeUpdateTextAnswerArgs = {
  input: UpdateTextAnswerInput;
};

export type RootMutationTypeUpdateTextQuestionArgs = {
  input: UpdateTextQuestionInput;
};

export type RootQueryType = {
  __typename?: "RootQueryType";
  /** List candidate imports */
  candidateImports: Maybe<CandidateImportConnection>;
  /** List candidates */
  candidates: Maybe<CandidateConnection>;
  /** Returns a caplena project. */
  caplenaProject: CaplenaProject;
  /** List caplena projects. */
  caplenaProjects: Array<CaplenaProject>;
  /** List clients */
  clients: Maybe<ClientConnection>;
  /** Returns a guest token for participating in a survey. */
  guestToken: Scalars["String"]["output"];
  /** Load Object by Global ID */
  node: Maybe<Node>;
  /** List projects. */
  projects: Maybe<ProjectConnection>;
  /** Returns all questions of a given survey. */
  questions: Maybe<QuestionConnection>;
  /** List surveys */
  surveys: Maybe<SurveyConnection>;
};

export type RootQueryTypeCandidateImportsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  surveyId: Scalars["ID"]["input"];
};

export type RootQueryTypeCandidatesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<CandidateStatus>;
  surveyId: Scalars["ID"]["input"];
};

export type RootQueryTypeCaplenaProjectArgs = {
  id: Scalars["ID"]["input"];
};

export type RootQueryTypeClientsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RootQueryTypeGuestTokenArgs = {
  subjectId: Scalars["ID"]["input"];
};

export type RootQueryTypeNodeArgs = {
  id: Scalars["ID"]["input"];
};

export type RootQueryTypeProjectsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  clientId: Scalars["ID"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RootQueryTypeQuestionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  questionTypes?: InputMaybe<Array<QuestionType>>;
  surveyId: Scalars["ID"]["input"];
};

export type RootQueryTypeSurveysArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  projectId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type SendFinishEmailsInput = {
  surveyId: Scalars["ID"]["input"];
  testSend?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SendFinishEmailsPayload = {
  __typename?: "SendFinishEmailsPayload";
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages: Maybe<Array<Maybe<ValidationMessage>>>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars["Boolean"]["output"];
};

export type SendInvitationEmailsInput = {
  surveyId: Scalars["ID"]["input"];
  testSend?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SendInvitationEmailsPayload = {
  __typename?: "SendInvitationEmailsPayload";
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages: Maybe<Array<Maybe<ValidationMessage>>>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars["Boolean"]["output"];
};

export type SendReminderEmailsInput = {
  surveyId: Scalars["ID"]["input"];
  testSend?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SendReminderEmailsPayload = {
  __typename?: "SendReminderEmailsPayload";
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages: Maybe<Array<Maybe<ValidationMessage>>>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars["Boolean"]["output"];
};

/** Survey */
export type Survey = Node &
  Resource & {
    __typename?: "Survey";
    autoSendInvitationEmails: Maybe<Scalars["Boolean"]["output"]>;
    backgroundImage: Maybe<Scalars["Uri"]["output"]>;
    caplenaId: Maybe<Scalars["ID"]["output"]>;
    corporateConfiguration: Maybe<SurveyCorporateConfiguration>;
    endButtonText: Maybe<Scalars["String"]["output"]>;
    finishEmailConfiguration: FinishEmailConfiguration;
    footerMarkdown: Maybe<Scalars["String"]["output"]>;
    /** The ID of an object */
    id: Scalars["ID"]["output"];
    inheritedCorporateConfiguration: SurveyCorporateConfiguration;
    insertedAt: Scalars["Datetime"]["output"];
    introImage: Maybe<Scalars["Uri"]["output"]>;
    introMarkdown: Maybe<Scalars["String"]["output"]>;
    introVideo: Maybe<Scalars["String"]["output"]>;
    invitationEmailConfiguration: InvitationEmailConfiguration;
    language: SurveyLanguage;
    name: Scalars["String"]["output"];
    outroImage: Maybe<Scalars["Uri"]["output"]>;
    outroMarkdown: Maybe<Scalars["String"]["output"]>;
    outroVideo: Maybe<Scalars["String"]["output"]>;
    precedingSurvey: Maybe<Survey>;
    project: Project;
    reminderEmailConfiguration: ReminderEmailConfiguration;
    resultUrl: Maybe<Scalars["String"]["output"]>;
    showPullsBranding: Maybe<Scalars["Boolean"]["output"]>;
    showResultsFromPrecedingSurvey: Scalars["Boolean"]["output"];
    startButtonText: Maybe<Scalars["String"]["output"]>;
    status: SurveyStatus;
    surveyExport: Scalars["Uri"]["output"];
    updatedAt: Scalars["Datetime"]["output"];
  };

/** Survey */
export type SurveyBackgroundImageArgs = {
  size: ImageSize;
};

/** Survey */
export type SurveyIntroImageArgs = {
  size: ImageSize;
};

/** Survey */
export type SurveyOutroImageArgs = {
  size: ImageSize;
};

export type SurveyConnection = {
  __typename?: "SurveyConnection";
  edges: Maybe<Array<Maybe<SurveyEdge>>>;
  pageInfo: PageInfo;
};

/** Survey corporate configuration */
export type SurveyCorporateConfiguration = {
  __typename?: "SurveyCorporateConfiguration";
  logo: Maybe<Scalars["Uri"]["output"]>;
  primaryColor: Maybe<Scalars["String"]["output"]>;
  secondaryColor: Maybe<Scalars["String"]["output"]>;
};

/** Survey corporate configuration */
export type SurveyCorporateConfigurationLogoArgs = {
  size: ImageSize;
};

/** Survey corporate configuration input */
export type SurveyCorporateConfigurationInput = {
  logo?: InputMaybe<Scalars["Upload"]["input"]>;
  primaryColor?: InputMaybe<Scalars["String"]["input"]>;
  secondaryColor?: InputMaybe<Scalars["String"]["input"]>;
};

export type SurveyEdge = {
  __typename?: "SurveyEdge";
  cursor: Maybe<Scalars["String"]["output"]>;
  node: Maybe<Survey>;
};

export enum SurveyLanguage {
  Af = "AF",
  Ca = "CA",
  Cs = "CS",
  Da = "DA",
  De = "DE",
  El = "EL",
  En = "EN",
  Es = "ES",
  Et = "ET",
  Eu = "EU",
  Fi = "FI",
  Fr = "FR",
  Gl = "GL",
  Hu = "HU",
  Is = "IS",
  It = "IT",
  Lb = "LB",
  Lt = "LT",
  Lv = "LV",
  Mk = "MK",
  Nl = "NL",
  No = "NO",
  Pl = "PL",
  Pt = "PT",
  Ro = "RO",
  Sk = "SK",
  Sl = "SL",
  Sq = "SQ",
  Sr = "SR",
  Sv = "SV",
  Tr = "TR",
}

export enum SurveyStatus {
  Done = "DONE",
  Planning = "PLANNING",
  Running = "RUNNING",
  Testing = "TESTING",
}

/** Text answer */
export type TextAnswer = Answer &
  Node &
  Resource & {
    __typename?: "TextAnswer";
    /** The ID of an object */
    id: Scalars["ID"]["output"];
    insertedAt: Scalars["Datetime"]["output"];
    participation: Participation;
    question: Question;
    updatedAt: Scalars["Datetime"]["output"];
    value: Maybe<Scalars["String"]["output"]>;
  };

/** Text question. */
export type TextQuestion = Node &
  Question &
  Resource & {
    __typename?: "TextQuestion";
    caplenaRef: Maybe<Scalars["String"]["output"]>;
    createCaplenaColumn: Maybe<Scalars["Boolean"]["output"]>;
    description: Maybe<Scalars["String"]["output"]>;
    /** The ID of an object */
    id: Scalars["ID"]["output"];
    insertedAt: Scalars["Datetime"]["output"];
    isSkippable: Maybe<Scalars["Boolean"]["output"]>;
    previousQuestion: Maybe<Question>;
    survey: Survey;
    title: Scalars["String"]["output"];
    updatedAt: Scalars["Datetime"]["output"];
  };

export type Topic = {
  __typename?: "Topic";
  answer: Maybe<Answer>;
  question: Question;
};

export type UpdateClientInput = {
  clientId: Scalars["ID"]["input"];
  corporateConfiguration?: InputMaybe<ClientCorporateConfigurationInput>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateClientPayload = {
  __typename?: "UpdateClientPayload";
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result: Maybe<Client>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars["Boolean"]["output"];
};

export type UpdateMetadataQuestionInput = {
  caplenaRef?: InputMaybe<Scalars["String"]["input"]>;
  createCaplenaColumn?: InputMaybe<Scalars["Boolean"]["input"]>;
  questionId: Scalars["ID"]["input"];
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateMetadataQuestionPayload = {
  __typename?: "UpdateMetadataQuestionPayload";
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result: Maybe<MetadataQuestion>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars["Boolean"]["output"];
};

export type UpdateMultipleChoiceAnswerInput = {
  answerId: Scalars["ID"]["input"];
  value?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type UpdateMultipleChoiceAnswerPayload = {
  __typename?: "UpdateMultipleChoiceAnswerPayload";
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result: Maybe<MultipleChoiceAnswer>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars["Boolean"]["output"];
};

export type UpdateMultipleChoiceQuestionInput = {
  caplenaRef?: InputMaybe<Scalars["String"]["input"]>;
  choices?: InputMaybe<Array<Scalars["String"]["input"]>>;
  createCaplenaColumn?: InputMaybe<Scalars["Boolean"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  isSkippable?: InputMaybe<Scalars["Boolean"]["input"]>;
  maxChoices?: InputMaybe<Scalars["Int"]["input"]>;
  minChoices?: InputMaybe<Scalars["Int"]["input"]>;
  previousQuestionId?: InputMaybe<Scalars["ID"]["input"]>;
  questionId: Scalars["ID"]["input"];
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateMultipleChoiceQuestionPayload = {
  __typename?: "UpdateMultipleChoiceQuestionPayload";
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result: Maybe<MultipleChoiceQuestion>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars["Boolean"]["output"];
};

export type UpdateProjectInput = {
  corporateConfiguration?: InputMaybe<ProjectCorporateConfigurationInput>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  projectId: Scalars["ID"]["input"];
};

export type UpdateProjectPayload = {
  __typename?: "UpdateProjectPayload";
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result: Maybe<Project>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars["Boolean"]["output"];
};

export type UpdateSurveyInput = {
  autoSendInvitationEmails?: InputMaybe<Scalars["Boolean"]["input"]>;
  backgroundImage?: InputMaybe<Scalars["Upload"]["input"]>;
  caplenaCleanup?: InputMaybe<Scalars["Boolean"]["input"]>;
  caplenaId?: InputMaybe<Scalars["ID"]["input"]>;
  corporateConfiguration?: InputMaybe<SurveyCorporateConfigurationInput>;
  endButtonText?: InputMaybe<Scalars["String"]["input"]>;
  finishEmailConfiguration?: InputMaybe<FinishEmailConfigurationInput>;
  footerMarkdown?: InputMaybe<Scalars["String"]["input"]>;
  introImage?: InputMaybe<Scalars["Upload"]["input"]>;
  introMarkdown?: InputMaybe<Scalars["String"]["input"]>;
  introVideo?: InputMaybe<Scalars["String"]["input"]>;
  invitationEmailConfiguration?: InputMaybe<InvitationEmailConfigurationInput>;
  language?: InputMaybe<SurveyLanguage>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  outroImage?: InputMaybe<Scalars["Upload"]["input"]>;
  outroMarkdown?: InputMaybe<Scalars["String"]["input"]>;
  outroVideo?: InputMaybe<Scalars["String"]["input"]>;
  precedingSurveyId?: InputMaybe<Scalars["ID"]["input"]>;
  projectId?: InputMaybe<Scalars["ID"]["input"]>;
  reminderEmailConfiguration?: InputMaybe<ReminderEmailConfigurationInput>;
  resultUrl?: InputMaybe<Scalars["String"]["input"]>;
  showPullsBranding?: InputMaybe<Scalars["Boolean"]["input"]>;
  showResultsFromPrecedingSurvey?: InputMaybe<Scalars["Boolean"]["input"]>;
  startButtonText?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<SurveyStatus>;
  surveyId: Scalars["ID"]["input"];
};

export type UpdateSurveyPayload = {
  __typename?: "UpdateSurveyPayload";
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result: Maybe<Survey>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars["Boolean"]["output"];
};

export type UpdateTextAnswerInput = {
  answerId: Scalars["ID"]["input"];
  value?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateTextAnswerPayload = {
  __typename?: "UpdateTextAnswerPayload";
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result: Maybe<TextAnswer>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars["Boolean"]["output"];
};

export type UpdateTextQuestionInput = {
  caplenaRef?: InputMaybe<Scalars["String"]["input"]>;
  createCaplenaColumn?: InputMaybe<Scalars["Boolean"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  isSkippable?: InputMaybe<Scalars["Boolean"]["input"]>;
  previousQuestionId?: InputMaybe<Scalars["ID"]["input"]>;
  questionId: Scalars["ID"]["input"];
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateTextQuestionPayload = {
  __typename?: "UpdateTextQuestionPayload";
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result: Maybe<TextQuestion>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars["Boolean"]["output"];
};

/**
 * Validation messages are returned when mutation input does not meet the requirements.
 *   While client-side validation is highly recommended to provide the best User Experience,
 *   All inputs will always be validated server-side.
 *
 *   Some examples of validations are:
 *
 *   * Username must be at least 10 characters
 *   * Email field does not contain an email address
 *   * Birth Date is required
 *
 *   While GraphQL has support for required values, mutation data fields are always
 *   set to optional in our API. This allows 'required field' messages
 *   to be returned in the same manner as other validations. The only exceptions
 *   are id fields, which may be required to perform updates or deletes.
 */
export type ValidationMessage = {
  __typename?: "ValidationMessage";
  /** A unique error code for the type of validation used. */
  code: Scalars["String"]["output"];
  /**
   * The input field that the error applies to. The field can be used to
   * identify which field the error message should be displayed next to in the
   * presentation layer.
   *
   * If there are multiple errors to display for a field, multiple validation
   * messages will be in the result.
   *
   * This field may be null in cases where an error cannot be applied to a specific field.
   */
  field: Maybe<Scalars["String"]["output"]>;
  /**
   * A friendly error message, appropriate for display to the end user.
   *
   * The message is interpolated to include the appropriate variables.
   *
   * Example: `Username must be at least 10 characters`
   *
   * This message may change without notice, so we do not recommend you match against the text.
   * Instead, use the *code* field for matching.
   */
  message: Maybe<Scalars["String"]["output"]>;
  /** A list of substitutions to be applied to a validation message template */
  options: Maybe<Array<Maybe<ValidationOption>>>;
  /**
   * A template used to generate the error message, with placeholders for option substitution.
   *
   * Example: `Username must be at least {count} characters`
   *
   * This message may change without notice, so we do not recommend you match against the text.
   * Instead, use the *code* field for matching.
   */
  template: Maybe<Scalars["String"]["output"]>;
};

export type ValidationOption = {
  __typename?: "ValidationOption";
  /** The name of a variable to be substituted in a validation message template */
  key: Scalars["String"]["output"];
  /** The value of a variable to be substituted in a validation message template */
  value: Scalars["String"]["output"];
};
